export const CRON_JOBS = {
  CLOSE_OUT: 'close-out',
  EMPLOYEE_TIME_CARD_SERVICE: 'employee-timecard-service',
  DAILY_REPORT: 'daily-report',
  WEEKLY_REPORT: 'weekly-report',
  AUTO_INTEGRATIONS: 'auto-integrations',
  DATA_CLEANING: 'data-cleaning',
  AUTO_DEALS: 'auto-deals',
  AUTO_GUESTS: 'auto-guests',
  AUTO_JOURNEYS: 'auto-journeys',
  WEBSITE_ANALYTICS: 'website-analytics',
  AUTO_TRIPADVISOR_REVIEWS: 'auto-tripadvisor',
  AUTO_AI_REVIEWS: 'auto-ai-reviews',
  AUTO_SCRAPPER_REVIEWS: 'auto-scrapper-reviews',
  CAMPAIGN_APPROVAL_REMINDER: 'campaign-approval-reminder',
  CAMPAIGN_MISSED: 'campaign-missed',
  AI_DOC_VAULT_EXPIRY: 'ai-docs-expiry',
  SUCCESSFUL_CLOSE_OUT_EMAIL: 'successful-close-out-email',
  CALCULATE_ACCOUNTING_ORDER_PLACEMENT: 'calculate-accounting-order-placement',
  CAPTURE_PAYMENT: 'capture-payment',
  CLEAN_UP_INVENTORY_LOGS: 'clean-up-inventory-logs',
  AUTO_GUEST_SEGMENT: 'auto-guest-segment',
  TIMEOFF_RESET_CYCLE: 'timeoff-reset-cycle',
} as const;

export type CronJobKeys = keyof typeof CRON_JOBS;

export enum CRON_JOB_TYPE {
  TENANT_SPECIFIC = 'tenant-specific',
  RESTAURANT_SPECIFIC = 'restaurant-specific',
  SYSTEM_WIDE = 'system-wide',
}

export interface TenantRestaurantConfig {
  tenant: number;
  restaurantIds: number[];
}
